import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    paddingInlineEnd: 56,
    paddingInlineStart: 56,

    '@media (max-width: 1180px)': {
      paddingInlineStart: 0,
      paddingInlineEnd: 0,
    },
  },
  filterContainer: {
    paddingBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',

    '@media (max-width: 843px)': {
      flexDirection: 'column',
    },
  },
  filters: {
    maxWidth: '50%',
    flexBasis: '50%',

    '@media (max-width: 843px)': {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  copyButtons: {
    minWidth: 'auto',
    padding: 6,
  },
  detailsRow: {
    '&:hover': {
      backgroundColor: variables.white,
      borderRadius: 8,
    },
  },
  detailsItem: {
    height: 35,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,

    '@media (max-width: 600px)': {
      marginBottom: 15,
    },
  },
  quickReports: {
    maxWidth: '16.66%',
    flexBasis: '16.66%',

    '@media (max-width: 1180px)': {
      width: 150,
      maxWidth: 150,
      flexBasis: 'unset',
      display: 'inline-block',
      whiteSpace: 'pre-line',
    },
  },
  panels: {
    marginTop: 10,
    marginBottom: 10,

    '@media (max-width: 1180px)': {
      display: 'block',
      overflowX: 'scroll',
      whiteSpace: 'nowrap',
    },
  },
  showInfoRow: {
    paddingLeft: 8,
    textAlign: 'start',
  },
  columnName: {
    fontWeight: 400,
    fontSize: 16,
    textAlign: 'start',
    color: variables.black50,
    cursor: 'pointer',
  },
  columnValue: {
    fontWeight: 600,
    fontSize: 16,
    textAlign: 'end',
    color: variables.richBlack,
    cursor: 'pointer',
  },
}));
